<template>
  <div class="relative">
    <!-- <div class="saleTag" v-if="saleTag">{{ saleTag }}</div> -->
    <div class="product" @click="toProduct(data.data)" :style="{ 'background-color': data.backgroudColor }"
      :class="{ shadow: shadow }">
      <div class="product-in" :style="{ padding: `${padding} ${padding} 8px ${padding}` }">
        <div class="brand" v-if="showBrand && data.data.brandName && data.data.brandLogoFlag == 1">
          {{ data.data.brandName }}
        </div>
        <div class="img" :title="data.data.name">
          <div class="in-img" :class="{ disabled: data.disabled }" :style="{
              backgroundImage: `url(${finallyImg})`,
            }"></div>
        </div>
        <div :style="{ 'text-align': data.textAlign }">
          <el-tag v-if="data.tag" type="danger" effect="dark" class="mt-8px" size="small">
            {{ data.tag }}
          </el-tag>
          <!-- 标题显示两行 -->

          <div class="title leading-24px h-48px" :style="{ 'font-size': data.fontSize }" :title="data.data.name">
            <div class="activity-bg rounded-2px px-1 YouSheBiaoTiHei float-left mr-1 leading-18px mt-1 text-white"
              v-if="showActivityName && activityName">
              {{ activityName }}
            </div>
            {{ data.data.name }}
          </div>
          <!-- 卖点  -->
          <div class="h-18px leading-18px text-[#FE7036] text-12px" v-if="showPromotionActivityFlag">
            {{ showPromotionActivityFlag && data.data?.promotionActivityFlag ? data.data.promotionActivityFlag : '' }}
          </div>
          <div class="price" :style="{ 'font-size': data.moneySize }" v-if="!hiddenPrice && showPrice">
            <span class="start !ml-0 mr-1"  v-if="showPriceDescTitle">{{ priceDescTitle }}</span>
            <span v-if="data.data.originalPrice" class="originalPrice">
              <formatMoney :value="data.data.originalPrice" :showAll="data.showAll" />
            </span>
            <span v-if="costPrice" class="originalPrice">
              <formatMoney :value="costPrice" :showAll="data.showAll" />
            </span>
            <!-- 询价不展示 -->
            <span v-if="!data.data.consultIndex">
              <formatMoney :value="activityPrice" class="leading-32px text-[#FE7036] text-20px"
                :showAll="data.showAll" />
              <span v-if="showPoint" class="leading-32px text-[#FE7036] text-14px">
                <span>+</span>
                <FormatPoint :point="activityPoint" />
                </FormatPoint>
              </span>
            </span>
            <span class="!text-$main-color !text-14px leading-32px" v-else>前往询价</span>
            <!-- <span class="start">起</span> -->
          </div>
          <el-tooltip class="item" effect="dark" :content="data.data.supplierCompanyName" placement="top-end"
            v-if="data.data.hostId != 1">
            <div class="companyName" v-if="data.showCompany">供应商：{{ data.data.supplierCompanyName }}</div>
          </el-tooltip>
          <div class="btn-warp flex" v-if="data.showButton">
            <slot name="productHandle" :row="data.data"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import productEmpty from '@/assets/images/productEmpty.png';
import { generateImageFromText } from '@/utils/defaultImageGenerator';
import { appInfo } from '@/stores/appInfo';
import { userInfo } from '@/stores/userInfo';
import { isDefined } from '@vueuse/core';
const appStores = appInfo();
const userStore = userInfo();
const data = defineProps({
  // 产品数据
  data: {
    type: Object,
    default: () => {},
  },
  // 是否显示供应商
  showCompany: {
    type: Boolean,
    default: true,
  },

  // 是否显示按钮
  showButton: {
    type: Boolean,
    default: false,
  },
  // 是否失效商品
  disabled: {
    type: Boolean,
    default: false,
  },
  // 显示所有的价格位数
  showAll: {
    type: Boolean,
    default: true,
  },
  // 背景颜色
  backgroudColor: {
    type: String,
    default: '#fff',
  },
  // padding
  padding: {
    type: String,
    default: '16px',
  },
  // 文字的对齐方式
  textAlign: {
    type: String,
    default: 'left',
  },
  // 是否显示品牌
  showBrand: {
    type: Boolean,
    default: false,
  },
  // 标签
  tag: {
    type: String,
    default: '',
  },
  //阴影
  shadow: {
    type: Boolean,
    default: false,
  },
  //文字大小
  fontSize: {
    type: String,
    default: '16px',
  },
  //金额大小
  moneySize: {
    type: String,
    default: '20px',
  },
  //所属专区
  zoneId: {
    type: [String, Number],
    default: '',
  },
  //促销标签
  saleTag: {
    type: String,
    default: '',
  },
  //被划掉的原价
  costPrice: {
    type: String,
    default: '',
  },
  // 是否展示活动名称
  showActivityName: {
    type: Boolean,
    default: true,
  },
  // 是否展示卖点
  showPromotionActivityFlag: {
    type: Boolean,
    default: false,
  },
  // 是否展示价格
  showPrice: {
    type: Boolean,
    default: true,
  },
  showPriceDescTitle: {
    type: Boolean,
    default: false,
  }
});
const finallyImg = ref(null);
// 是否展示价格,中小企业，价格和协议价格都为空得时候不展示价格
const hiddenPrice = computed(() => {

  return (
     data.data.hostId == userStore.defaultHostId && !isDefined(data.data.price) && !isDefined(data.data.protocolPrice)
  );
});
// 是否为协议价
const isProtocolPrice = computed(() => {
  return data.data.hostId == userStore.defaultHostId && isDefined(data.data.protocolPrice);
});

// 产品价格
const productPrice = computed(() => {
  if (data.data.hostId == userStore.defaultHostId) {
    // 中小企业，价格和协议价格都存在的情况下，展示协议价格
    if (isDefined(data.data.protocolPrice)) {
      return data.data.protocolPrice;
    } else {
      return data.data.price;
    }
  } else {
    // 促销价
    if (data.data.promoActivityList?.find(item => item.strategyType == 2) && data.data.promotionPrice) {
      return data.data.promotionPrice
    }
    return data.data.price;
  }
});

// 金额折扣
const pricePercentage = computed(() => {
  const promoActivity = data.data.promoActivityList?.find(item => item.strategyType == 2) 
  const activities = promoActivity ? promoActivity : data.data.promoActivityList?.[0];
  if (!activities) return 100;
  if (activities.mixedPayment == 1) {
    return Big(100).minus(activities.pointPercentage);
  } else {
    return 100;
  }
});

// 促销价优惠金额
const activityPrice = computed(() => {
  return Big(Number(productPrice.value)).times(pricePercentage.value).div(100);
});

// 抵扣积分
const activityPoint = computed(() => {
  return Big(Number(productPrice.value)).minus(activityPrice.value).times(100).toFixed(0);
});

// 是否显示积分
const showPoint = computed(() => {
  return activityPoint.value == '0' ? false : true;
});

// 活动名称
const activityName = computed(() => {
  return (
    (data.data.promoActivityList && (data.data.promoActivityList.length ? data.data.promoActivityList[0].name : '')) ||
    ''
  );
});

// 价格描述标题 计算属性
const priceDescTitle = computed(() => {
  if (isProtocolPrice.value) {
    return '协议价'
  } else if (data.data.consultIndex) {
    return ''
  } else if (data.data.promoActivityList?.find(item => item.strategyType==2)) {
    return '促销价'
  } else {
    return '含税价'
  }
  
});

onMounted(async () => {
  if (data.data.pic) {
    finallyImg.value = data.data.pic;
  } else {
    finallyImg.value = await generateImageFromText(data.data.name);
  }
});

function toProduct(product) {
  let url = '';
  if (product.hostId != 1) {
    url = import.meta.env.VITE_APP_DOMAIN_INNER;
  } else {
    if (data.zoneId == 3) {
      url = import.meta.env.VITE_APP_DOMAIN_POINT;
    } else {
      url = import.meta.env.VITE_APP_DOMAIN;
    }
  }

  if (!data.disabled) {
    let routeUrl = `${url}/product/${product.id}${data.zoneId ? `?zoneId=${data.zoneId}` : ''}`;
    window.open(routeUrl, '_blank');
  }
}
</script>
<style lang="scss" scoped>
.shadow {
  box-shadow: 0px 4px 20px 2px rgba(0, 0, 0, 0.06);
}
.saleTag {
  position: absolute;
  background: url('@/assets/images/saleTag.png') no-repeat;
  background-size: contain;
  font-size: 14px;
  font-weight: bold;
  padding: 9px 24px 25px 17px;
  color: #fff;
  z-index: 1;
  left: -14px;
  top: 12px;
}
.product {
  cursor: pointer;
  overflow: hidden;
  border-radius: 6px;

  .product-in {
    position: relative;

    .brand {
      position: absolute;
      top: 0;
      left: 0;
      background: $main-color;
      border-radius: 0 0 6px 0;
      padding: 8px 16px;
      font-size: 14px;
      color: #fff;
      z-index: 2;
    }

    .img {
      width: 100%;
      overflow: hidden;
      border-radius: 6px;

      .in-img {
        height: 0px;
        padding-bottom: 100%;
        background: #fff no-repeat center center;
        background-size: contain;
        position: relative;
      }

      .disabled {
        &::before {
          content: '失效商品';
          position: absolute;
          background: rgba(0, 0, 0, 0.4);
          width: 193px;
          height: 193px;
          line-height: 193px;
          font-size: 16px;
          text-align: center;
          color: #fff;
        }
      }
    }

    .title {
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      line-height: 1.5;
      margin: 6px 0 4px 0;
      // height: 1.5em;
      overflow-wrap: anywhere;
      color: #333333;
    }

    .price {
      color: $main-color-red;
      // font-weight: bold;

      .start {
        font-size: 12px;
        color: $main-text-color2;
        margin-left: 4px;
        font-weight: normal;
      }

      .originalPrice {
        display: block;
        margin: 8px 0 2px;
        font-weight: normal;
        // margin-left: 12px;
        text-decoration: line-through;
        font-size: 12px;
        color: $main-text-color2;
      }
    }

    .companyName {
      font-size: 12px;
      color: $main-text-color2;
      margin-top: 12px;
      line-height: 1.5;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    &:hover {
      .title {
        color: $main-color;
      }
    }

    .btn-warp {
      margin-top: 12px;

      .el-button {
        padding: 6px 0;
        flex-grow: 1;
      }
    }
  }
}

.activity-bg {
  background: linear-gradient(90deg, #ff9e5b 0%, #fe7036 100%);
}
</style>
